import hydrateDocuments from './hydrateDocuments'

const updateDocumentsQuery = store => ({
  page,
  sortBy,
  sortDirection,
  search,
  filters,
}) => {
  store.setState({documentCenterPage: page || 1})
  store.setState({documentCenterSortBy: sortBy || '_createdAt'})
  store.setState({documentCenterSortDirection: sortDirection || 'desc'})
  store.setState({documentCenterSearch: search || ''})
  if (filters) store.setState({documentCenterFilters: JSON.parse(filters)})

  hydrateDocuments(store)()
}

export default updateDocumentsQuery
